var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return false
    ? _c("div", { staticClass: "viq-sub-bar" }, [
        _c("span", { staticClass: "viq-sub-bar__label" }, [
          _vm._v(_vm._s(_vm.verticalLabel)),
        ]),
        _vm._v(" "),
        _vm.tierLabel
          ? _c("span", { staticClass: "viq-sub-bar__tier" }, [
              _vm._v(_vm._s(_vm.tierLabel)),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }